<spinner-overlay id="spinner"></spinner-overlay>
<div #printArea id="printdiv" class="h-full w-full flex flex-col">
  <layout-navbar-v2></layout-navbar-v2>
  <div class="flex min-h-0 flex-1">
    <layout-sidebar></layout-sidebar>
    <!-- Main content -->
    <main pdfExportHost class="flex flex-col flex-1 max-w-full overflow-x-auto border-t min-h-0 border-[#adadad]">
      <!-- Breadcrumb -->
      <layout-breadcrumb *ngIf="showBreadcrumb$ | async"></layout-breadcrumb>
      <app-report-filter-bar *ngIf="showReportFilterBar$ | async"></app-report-filter-bar>
      <div id="main-content" *ngIf="layoutHelper.sideNavToggleAction$ | async as toggleStatus" class="flex-1 flex min-h-0">
        <!-- Router Content -->
        <div class="w-full max-w-full overflow-x-auto flex flex-col items-stretch" [@contentSlide]="toggleStatus">
          <router-outlet></router-outlet>
        </div>
      </div>
    </main>
  </div>
  <layout-footer></layout-footer>
</div>
